<template>
  <v-dialog v-model="removeDialog" max-width="349">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon class="delete-btn" v-bind="attrs" v-on="on">
        <v-icon small>$icon-trash</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title align="center" style="color: #F83030;">Apagar {{target}}</v-card-title>
      <v-card-text>Apagar este {{target}} é irreversível, ao fazê-lo, se pretender voltar a usá-lo terá de criar um novo.</v-card-text>
      <v-list-item style="padding-bottom: 12px;">
        <v-list-item-content style="padding-right: 8px;">
          <v-btn block depressed color="secondary" height="48" @click="removeDialog = false">Cancelar</v-btn>
        </v-list-item-content>
        <v-list-item-content style="padding-left: 8px;">
          <v-btn block depressed dark color="#F83030" height="48" @click="$emit('remove-item'); removeDialog = false;">Apagar</v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "RemoveItem",
  props: {
    target: String
  },
  data: () => ({
    removeDialog: false
  }),
  methods: {
  }
});
</script>
